<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Reenviar Correo de Notificación.</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="Cita!=null">
            <div class="row">
              <div class="col-4 border-right">
                <div class="row"><h4>Datos del Solicitante</h4></div>
                <div class="row"><b>Nombre: </b><span>{{Cita.InformacionDeSolicitante.NombreCompleto}}</span></div>
                <div class="row"><b>Teléfono: </b><span>{{Cita.InformacionDeSolicitante.Telefono}}</span></div>
                <div class="row"><b>Correo electrónico: </b><span>{{Cita.InformacionDeSolicitante.CorreoElectronico}}</span></div>
                <div class="row"><b>Fecha y hora solicitada: </b><span>{{Cita.AgendaBloque.FechaHoraString}}</span></div>
              </div>              
              <div class="col-8">
                <p>
                  <b>
                    Escriba el contenido del texto que será enviado al solicitante via correo electrónico a su dirección {{Cita.InformacionDeSolicitante.CorreoElectronico}}. Puede agregar información adicional al mensaje si es necesario.
                  </b>
                </p>
                <p v-html="textoGenerado"> </p>
                <textarea rows="5" class="form-control" v-model="textoEditable"></textarea>
                <div class="row">
                  <div class="col-4"></div>
                  <div class="col-4" style="margin-top:10px;">
                    <input type="button" class="form-control" value="Volver" @click="confirmacionCancelar" />
                  </div>
                  <div class="col-4" style="margin-top:10px;">
                    <input type="button" class="form-control" value="Enviar" @click="EnviarCorreoSolicitante" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    props: ['citaId'],
    data() {
      return {
        enumeraciones,
        catalogos,
        /*parametros_TiposEstatusDeExpedientes: {
          ValorDefinido: -1,
          TipoEstatusDeExpedienteId: null,
          ConInactivas: false
        },*/
        parametros_TiposEstatusDeExpedientes: [],
        Cita: null,
        NumeroFilasPagina: 10,
        listaExpedientesId: [],
        listaEstatusId: [],
        listaCheckBox: [],
        deshabilitarBotonConfirmar: false,
        estatusGuardados: false,
        textoGenerado: null,
        textoEditable: ""
      }
    },
    components: {
      C015TiposEstatusDeExpedientes: catalogos.SICCIJ.C015TiposEstatusDeExpedientes,
    },
    methods: {
      cargarInfoCita: function () { //Carga la información de BD de una cita
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.Cita = response.data.Cita
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      GenerarTextoCorreoAvisoSolicitanteDeCita: function () { //Obtiene el texto autogenerado para el correo de notificación.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        //comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GenerarTextoCorreoAvisoSolicitanteDeCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.textoGenerado = response.data.TextoGenerado;
            this.textoEditable = response.data.TextoEditable;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          //comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      EnviarCorreoSolicitante: function () { //Hace la petición de envio de correo electrónico al solicitante.
        var textoCorreo = this.textoGenerado.replace(/<br>/g, "\n");
        var peticion = {
          "esPrueba": false,
          "ContenidoCorreo": textoCorreo + "\n" + this.textoEditable,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.EnviarCorreoSolicitante, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.mensajeCorreoEnviado();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      confirmacionCancelar: function () { //Muestra un mensaje qué pide confirmar al usuario que desea cancelar el proceso de reenvío de correo.
        var funcion = this.volverNotifiacionesPendientes
        //comun.mensajeDeConfirmacion("¿Seguro que desea regresar a las citas pendientes, perdera los cambios en esta cita?", "No", "Sí", this.volverConsultaCitas, null, null, null);
        $('.bootbox.modal').modal('hide');
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Seguro que desea regresar a las citas pendientes?<br> Perdera los cambios en esta cita.",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No"
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí"
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              return funcion();
            }
          }
        });
      },
      mensajeCorreoEnviado: function () { //Notifica que el correo de notificación fué enviado correctamente.
        var funcion = this.volverNotifiacionesPendientes
        //comun.mensajeDeConfirmacion("¿Seguro que desea regresar a las citas pendientes, perdera los cambios en esta cita?", "No", "Sí", this.volverConsultaCitas, null, null, null);
        $('.bootbox.modal').modal('hide');
        bootbox.alert({
          title: "Mensaje del sistema",
          message: "Correo enviado satisfactoriamente.",
          buttons: {
            ok: {
              label: 'Aceptar'
            }
          },
          callback: function () {
            return funcion();
          }
        });
      },
      volverNotifiacionesPendientes: function () {//Redirige a la pantalla de 'NotificacionesPendientes'.
        //alert('volver')
        this.$router.push({
          name: 'NotificacionesPendientes'
        })
        return;
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.cargarInfoCita();
      this.GenerarTextoCorreoAvisoSolicitanteDeCita();
    }, computed: {

    }

  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  span {
    margin-bottom: 5px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/NotificacionesPendientes/ReenviarCorreo.vue